"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Storage = void 0;
const tslib_1 = require("tslib");
const base64_arraybuffer_1 = require("base64-arraybuffer");
const provider_1 = require("./provider");
const file_1 = require("./file");
class Storage {
    constructor(app) {
        this.app = app;
    }
    queryFile() {
        return this.app.database().class('_File', file_1.LCFile.fromJSON);
    }
    upload(name, data, options) {
        var _a, _b;
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            if (data.blob) {
                data = Object.assign(Object.assign({}, data.blob), { name, type: (_a = options === null || options === void 0 ? void 0 : options.mime) !== null && _a !== void 0 ? _a : data.blob.type });
            }
            else {
                data = parseFileData(data);
            }
            const metaData = Object.assign({}, options === null || options === void 0 ? void 0 : options.metaData);
            metaData.owner = (yield getCurrentUserID(this.app)) || 'unknown';
            if (typeof metaData.size !== 'number') {
                metaData.size = (_b = data.size) !== null && _b !== void 0 ? _b : data.length;
            }
            const tokens = yield this._getFileTokens(name, Object.assign(Object.assign({}, options), { metaData }));
            try {
                const provider = this._getFileProvider(tokens.provider);
                yield provider.upload(name, data, tokens, options);
                yield this._invokeFileCallback(tokens.token, true);
            }
            catch (e) {
                yield this._invokeFileCallback(tokens.token, false);
                throw e;
            }
            return file_1.LCFile.fromJSON(this.app, {
                name,
                metaData,
                objectId: tokens.objectId,
                bucket: tokens.bucket,
                key: tokens.key,
                mime_type: tokens.mime_type,
                provider: tokens.provider,
                url: tokens.url,
                createdAt: tokens.createdAt,
                updatedAt: tokens.createdAt,
            });
        });
    }
    uploadWithURL(name, url, options) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            const metaData = Object.assign(Object.assign({}, options === null || options === void 0 ? void 0 : options.metaData), { __source: 'external', owner: (yield getCurrentUserID(this.app)) || 'unknown', size: 0 });
            const obj = yield this.app
                .database()
                .class('_File')
                .add({
                name,
                url,
                metaData,
                ACL: options === null || options === void 0 ? void 0 : options.ACL,
                mime_type: options === null || options === void 0 ? void 0 : options.mime,
            }, Object.assign(Object.assign({}, options), { fetchData: true }));
            return new file_1.LCFile(obj);
        });
    }
    _getFileTokens(name, options) {
        return this.app.request({
            method: 'POST',
            path: '/1.1/fileTokens',
            body: {
                name,
                ACL: options === null || options === void 0 ? void 0 : options.ACL,
                key: options === null || options === void 0 ? void 0 : options.key,
                metaData: options === null || options === void 0 ? void 0 : options.metaData,
                mime_type: options === null || options === void 0 ? void 0 : options.mime,
            },
        });
    }
    _getFileProvider(name) {
        if (name in provider_1.providers) {
            return provider_1.providers[name];
        }
        throw new Error(`Uploading files to ${name} is not supported`);
    }
    _invokeFileCallback(token, success) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            yield this.app.request({
                method: 'POST',
                path: '/1.1/fileCallback',
                body: { token, result: success },
            });
        });
    }
}
exports.Storage = Storage;
function getCurrentUserID(app) {
    return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
        if (app.payload['current_user']) {
            return app.payload['current_user'].id;
        }
        const user_str = yield app.localStorage.getAsync('current_user');
        if (user_str) {
            return JSON.parse(user_str).objectId;
        }
        return null;
    });
}
function base64InDataURLs(urls) {
    if (urls.startsWith('data:')) {
        const [meta, data] = urls.split(',');
        if (meta === null || meta === void 0 ? void 0 : meta.endsWith('base64')) {
            return data;
        }
    }
    return urls;
}
function parseFileData(data) {
    if (typeof data === 'string') {
        if (typeof btoa !== 'undefined') {
            return parseFileData({ base64: btoa(data) });
        }
        if (typeof Buffer !== 'undefined') {
            return Buffer.from(data, 'utf-8');
        }
        throw new Error('The current platform does not support building file using UTF-8 encoded strings');
    }
    if (Array.isArray(data)) {
        const u8arr = new Uint8Array(data.length);
        data.forEach((v, i) => (u8arr[i] = v));
        if (typeof Blob !== 'undefined') {
            return new Blob([u8arr]);
        }
        if (typeof Buffer !== 'undefined') {
            return Buffer.from(u8arr);
        }
        throw new Error('The current platform does not support building file using a byte array');
    }
    if (typeof data.base64 === 'string') {
        const base64 = base64InDataURLs(data.base64);
        if (typeof Blob !== 'undefined') {
            return new Blob([(0, base64_arraybuffer_1.decode)(base64)]);
        }
        if (typeof Buffer !== 'undefined') {
            return Buffer.from(base64, 'base64');
        }
        throw new Error('The current platform does not support building file using base64 encoded strings');
    }
    return data;
}
